'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dDescription$0024 from "./presto.types$-Rule-Description$.js";
import * as $j_presto$002etypes$0024$002dRule$002dId$0024 from "./presto.types$-Rule-Id$.js";
import * as $j_presto$002etypes$0024$002dRule$002dName$0024 from "./presto.types$-Rule-Name$.js";
import * as $j_presto$002etypes$0024proto$0024 from "./presto.types$proto$.js";
var $p;
/** @constructor */
function $c_Lpresto_Rules$$anon$2(outer) {
  this.buO = null;
  this.buM = null;
  this.buN = false;
  this.buK = null;
  this.buL = false;
  this.buP = false;
  this.buQ = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.buO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Rules$$anon$2 as $c_Lpresto_Rules$$anon$2 };
$p = $c_Lpresto_Rules$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Rules$$anon$2;
/** @constructor */
function $h_Lpresto_Rules$$anon$2() {
}
export { $h_Lpresto_Rules$$anon$2 as $h_Lpresto_Rules$$anon$2 };
$h_Lpresto_Rules$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.buO;
});
$p.t = (function() {
  if ((!this.buN)) {
    this.buM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("payload", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.buN = true;
  }
  return this.buM;
});
$p.ad = (function() {
  if ((!this.buL)) {
    this.buK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dRule$002dId$0024.$m_Lpresto_types$RuleId$().a2q()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dName$0024.$m_Lpresto_types$RuleName$().cHG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dDescription$0024.$m_Lpresto_types$RuleDescription$().cHF(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024proto$0024.$m_Lpresto_types$proto$().cHH(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.buL = true;
  }
  return this.buK;
});
$p.v = (function() {
  if ((!this.buQ)) {
    this.buP = false;
    this.buQ = true;
  }
  return this.buP;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Rules$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Rules$$anon$2, "presto.Rules$$anon$2", ({
  QF: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Rules$$anon$2 as $d_Lpresto_Rules$$anon$2 };
//# sourceMappingURL=presto.-Rules$$anon$2.js.map
